import { Component } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, UrlSegment } from '@angular/router';
import { CoordinatorService } from 'coordinator';
@Component({
    selector: 'app-url-parser',
    templateUrl: './url-parser.component.html',
    styleUrls: ['./url-parser.component.scss'],
})
export class UrlParserComponent {
    constructor(
        private coords: CoordinatorService,
        private route: ActivatedRoute,
        private loc: Location,
    ) {}

    ngOnInit() {
        this.route.url.subscribe((ls: UrlSegment[]) => {
            const value = ls.pop()?.path;
            const tag = ls.pop()?.path;

            switch (tag) {
                case 'p':
                    value && this.coords.serverPayload(value);
                    break;
                case 'pc':
                    value && this.coords.providerCode(value);
                    break;
                case 'pid':
                    this.coords.loadPublicFile(value!);
                    break;
                case 'apiLoad':
                    this.coords.loadAPI(value!);
                    break;
                case 'pil':
                    this.coords.openProjectOnStart(value!);
                    break;
                case 'cpn':
                    this.coords.openCoupon(value!);
                    break;
            }
            this.loc.replaceState('/');
        });
    }
}
